import { motion } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import { FaWhatsapp, FaUser } from "react-icons/fa";

export default function ContactUsPage() {
  return (
    <div className="flex-grow w-full bg-white py-8 px-6 md:px-16 lg:px-24">
      {/* Page Title */}
      <h1 className="mb-4 text-center">
        Contact Us
      </h1>

      {/* Animated Contact Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto bg-white/80 backdrop-blur-sm border border-green-100 rounded-2xl shadow-sm p-4 pl-8"
      >
        <div className="grid gap-4 md:gap-6">
          {/* Email */}
          <div className="flex items-center gap-4 text-left">
            <Mail className="text-green-600 w-6 h-6 shrink-0" />
            <span className="font-semibold text-gray-800 w-40 hidden md:inline-block">
              Inquiry Email
            </span>
            <span className="text-green-700 font-medium">
              squashhub97@gmail.com
            </span>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto bg-white/80 backdrop-blur-sm border border-green-100 rounded-2xl shadow-sm p-8 mt-4"
      >
        <div className="grid gap-4 md:gap-6">
          {/* Contact Person */}
          <div className="flex items-center gap-4 border-b border-green-100 pb-3 text-left">
            <FaUser className="text-green-600 w-6 h-6 shrink-0" />
            <span className="font-semibold text-gray-800 w-40 hidden md:inline-block">
              Contact Person
            </span>
            <span className="text-green-700 font-medium">Coach Lim Kai Zhen</span>
          </div>

          {/* Contact Number */}
          <div className="flex items-center gap-4 border-b border-green-100 pb-3 text-left">
            <Phone className="text-green-600 w-6 h-6 shrink-0" />
            <span className="font-semibold text-gray-800 w-40 hidden md:inline-block">
              Contact No
            </span>
            <span className="text-green-700 font-medium">+60 19-504 9830</span>
          </div>

          {/* WhatsApp */}
          <div className="flex items-center gap-4 text-left">
            <FaWhatsapp className="text-green-600 w-6 h-6 shrink-0" />
            <span className="font-semibold text-gray-800 w-40 hidden md:inline-block">
              WhatsApp
            </span>
            <span className="text-green-700 font-medium">+60 19-504 9830</span>
          </div>

          {/* Email */}
          {/* <div className="flex items-center gap-4 text-left">
            <Mail className="text-green-600 w-6 h-6 shrink-0" />
            <span className="font-semibold text-gray-800 w-40 hidden md:inline-block">
              Email
            </span>
            <span className="text-green-700 font-medium">
              limkaizhen96@gmail.com
            </span>
          </div> */}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto bg-white/80 backdrop-blur-sm border border-green-100 rounded-2xl shadow-sm p-8 mt-4"
      >
        <div className="grid gap-4 md:gap-6">
          {/* Contact Person */}
          <div className="flex items-center gap-4 border-b border-green-100 pb-3 text-left">
            <FaUser className="text-green-600 w-6 h-6 shrink-0" />
            <span className="font-semibold text-gray-800 w-40 hidden md:inline-block">
              Contact Person
            </span>
            <span className="text-green-700 font-medium">Coach Lim Ze Dong</span>
          </div>

          {/* Contact Number */}
          <div className="flex items-center gap-4 border-b border-green-100 pb-3 text-left">
            <Phone className="text-green-600 w-6 h-6 shrink-0" />
            <span className="font-semibold text-gray-800 w-40 hidden md:inline-block">
              Contact No
            </span>
            <span className="text-green-700 font-medium">+60 12-409 0566</span>
          </div>

          {/* WhatsApp */}
          <div className="flex items-center gap-4 text-left">
            <FaWhatsapp className="text-green-600 w-6 h-6 shrink-0" />
            <span className="font-semibold text-gray-800 w-40 hidden md:inline-block">
              WhatsApp
            </span>
            <span className="text-green-700 font-medium">+60 12-409 0566</span>
          </div>

          {/* Email */}
          {/* <div className="flex items-center gap-4 text-left">
            <Mail className="text-green-600 w-6 h-6 shrink-0" />
            <span className="font-semibold text-gray-800 w-40 hidden md:inline-block">
              Email
            </span>
            <span className="text-green-700 font-medium">
              zdlim97@gmail.com
            </span>
          </div> */}
        </div>
      </motion.div>
    </div>
  );
}
